import { PAGE_LABELS } from './rbac.js';

// The staff app routes on the hash, but some emails used to link to a path
// (https://ops.altonvalley.com/holidays). The Worker serves the app for any
// path, so those links opened on the dashboard. Emails already sent cannot be
// changed, so on first load a single-segment path naming a known page becomes
// that page's hash, and the usual aliases take it from there.
//
// Returns the hash to use, or null to leave the address alone: a hash already
// present wins, and anything that is not a known page (the portals and the
// office display included) keeps its path.
const PORTAL_PATHS = ['resource', 'client-portal', 'display'];

export function hashForLegacyPath(pathname, hash) {
  if (hash && hash !== '#') return null;
  const m = /^\/([a-z0-9-]+)\/?$/.exec(pathname || '');
  if (!m || PORTAL_PATHS.includes(m[1])) return null;
  return Object.prototype.hasOwnProperty.call(PAGE_LABELS, m[1]) ? `#${m[1]}` : null;
}
